import React, { useEffect, useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { Flame, Phone, Menu, X } from 'lucide-react';
export function Header() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const navLinks = [{
    name: 'Home',
    hash: '#home'
  }, {
    name: 'Services',
    hash: '#services'
  }, {
    name: 'About',
    hash: '#about'
  }, {
    name: 'Contact',
    hash: '#contact'
  }];
  const handleNavClick = (e: React.MouseEvent, hash: string) => {
    e.preventDefault();
    setIsMobileMenuOpen(false);
    if (location.pathname !== '/') {
      navigate('/' + hash);
      setTimeout(() => {
        const el = document.querySelector(hash);
        if (el) el.scrollIntoView({
          behavior: 'smooth'
        });
      }, 100);
    } else {
      const el = document.querySelector(hash);
      if (el) el.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  return <header className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isScrolled || location.pathname !== '/' ? 'bg-[#0a0a0a]/90 backdrop-blur-md border-b border-white/5 py-4' : 'bg-transparent py-6'}`} data-id="element-121" data-mp="2hpy5lsd23nhl">
      <div className="max-w-7xl mx-auto px-6 flex items-center justify-between" data-id="element-122" data-mp="35kr6sjeafvvj">
        {/* Logo */}
        <Link to="/" className="flex items-center gap-3 group" data-id="element-123" data-mp="30n7rdg5utd20">
          <div className="w-10 h-10 rounded-xl bg-gradient-primary p-[1px]" data-id="element-124" data-mp="1wfqgqe5ogye">
            <div className="w-full h-full bg-[#0a0a0a] rounded-xl flex items-center justify-center group-hover:bg-transparent transition-colors duration-300" data-id="element-125" data-mp="1yir04cxpshd">
              <Flame className="w-5 h-5 text-[#FF9500] group-hover:text-black transition-colors duration-300" data-id="element-126" data-mp="1remeekg6a2gp" />
            </div>
          </div>
          <div className="flex flex-col" data-id="element-127" data-mp="1wequ4899at5v">
            <span className="text-white font-bold text-lg leading-tight tracking-wide" data-id="element-128" data-mp="1hojnqqwix0lj">
              CLYDESIDE
            </span>
            <span className="text-xs text-gray-400 font-medium uppercase tracking-wider" data-id="element-129" data-mp="1mla1v8orpm4b">
              Gas Safe Heating
            </span>
          </div>
        </Link>

        {/* Desktop Nav */}
        <nav className="hidden md:flex items-center gap-8" data-id="element-130" data-mp="1cq8dif2bgo2s">
          {navLinks.map(link => <a key={link.name} href={link.hash} onClick={e => handleNavClick(e, link.hash)} className="text-sm font-medium text-gray-300 hover:text-white transition-colors relative group" data-id="element-131" data-mp="yqgsvvhao9ft">
              {link.name}
              <span className="absolute -bottom-1 left-0 w-0 h-[2px] bg-gradient-primary transition-all duration-300 group-hover:w-full" data-id="element-132" data-mp="2y0ymhteju91y"></span>
            </a>)}
        </nav>

        {/* Desktop Actions */}
        <div className="hidden md:flex items-center gap-6" data-id="element-133" data-mp="hh4tmawyrcwn">
          <a href="tel:07708233554" className="flex items-center gap-2 text-gray-300 hover:text-white transition-colors" data-id="element-134" data-mp="w4zifg7uox4g">
            <Phone className="w-4 h-4" data-id="element-135" data-mp="rbof3p28yyha" />
            <span className="text-sm font-semibold" data-id="element-136" data-mp="154cxcoequdwk">07708 233554</span>
          </a>
          <a href="#contact" onClick={e => handleNavClick(e, '#contact')} className="bg-gradient-primary text-black font-bold text-sm px-6 py-2.5 rounded-full hover:shadow-[0_0_20px_rgba(255,149,0,0.4)] transition-all duration-300 transform hover:-translate-y-0.5" data-id="element-137" data-mp="106bd405l08ji">
            Get a Quote
          </a>
        </div>

        {/* Mobile Menu Toggle */}
        <button className="md:hidden text-gray-300 hover:text-white" onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} aria-label="Toggle menu" data-id="element-138" data-mp="3bvvnobwe1c29">
          {isMobileMenuOpen ? <X className="w-6 h-6" data-id="element-139" data-mp="27wp6ecil34se" /> : <Menu className="w-6 h-6" data-id="element-140" data-mp="27zl5i4663zif" />}
        </button>
      </div>

      {/* Mobile Menu */}
      {isMobileMenuOpen && <div className="md:hidden absolute top-full left-0 right-0 bg-[#0a0a0a] border-b border-white/5 py-4 px-6 flex flex-col gap-4 shadow-2xl" data-id="element-141" data-mp="2gyq3n9dthqu2">
          {navLinks.map(link => <a key={link.name} href={link.hash} onClick={e => handleNavClick(e, link.hash)} className="text-lg font-medium text-gray-300 hover:text-white" data-id="element-142" data-mp="1p6qypxip7dpa">
              {link.name}
            </a>)}
          <div className="w-full h-px bg-white/10 my-2" data-id="element-143" data-mp="11ho8w2dwuejp"></div>
          <a href="tel:07708233554" className="flex items-center gap-2 text-white font-semibold text-lg" data-id="element-144" data-mp="11h6cn5r900bs">
            <Phone className="w-5 h-5 text-[#FF9500]" data-id="element-145" data-mp="xzs7opvyyv4q" />
            07708 233554
          </a>
          <a href="#contact" onClick={e => handleNavClick(e, '#contact')} className="bg-gradient-primary text-black font-bold text-center py-3 rounded-full mt-2" data-id="element-146" data-mp="t0nvdqdr0ha6">
            Get a Quote
          </a>
        </div>}
    </header>;
}